import { cons, ofArray, fold, append, indexed, map } from "./.fable/fable-library.3.1.16/List.js";
import { difference, empty, union, ofSeq, toList } from "./.fable/fable-library.3.1.16/Set.js";
import { join, printf, toText } from "./.fable/fable-library.3.1.16/String.js";
import { createElement } from "react";
import { Components_Cables_Z13D0F5DF, Components_Mod_4F7DC281, Components_Jack_Z1AD9156D, Controls_Knob_2C675436, Components_BlankCell_53DCD2D1, Components_Scope_Z52BA71AE } from "./Components.js";
import { LoadingState, getJack, validateJackPair as validateJackPair_1, ControlChangeEvent, Message } from "./Model.js";
import { Interop_reactApi } from "./.fable/Feliz.1.51.0/Interop.fs.js";
import { singleton, append as append_1, toList as toList_2, map as map_1, collect, delay } from "./.fable/fable-library.3.1.16/Seq.js";
import { rangeDouble } from "./.fable/fable-library.3.1.16/Range.js";
import { createObj, equals, equalArrays, compareArrays } from "./.fable/fable-library.3.1.16/Util.js";
import { tryFind, containsKey, toList as toList_1 } from "./.fable/fable-library.3.1.16/Map.js";
import { bind, map as map_2, defaultArg } from "./.fable/fable-library.3.1.16/Option.js";
import { getFloatValue, defs } from "./Mod.js";
import { throttle } from "./Throttle.js";

export function indexSet(f, s) {
    return map(f, indexed(toList(s)));
}

export function controls(dispatch, position_0, position_1, modState, jacks, controls_1) {
    const position = [position_0, position_1];
    if (modState.tag === 2) {
        let $keyZ6B097F4E;
        const tupledArg = position;
        $keyZ6B097F4E = toText(printf("%A"))([tupledArg[0], tupledArg[1]]);
        return createElement(Components_Scope_Z52BA71AE, {
            controls: append(jacks, controls_1),
            onRender: (canvas) => {
                dispatch(new Message(17, position, canvas));
            },
            scope: modState.fields[0],
            key: $keyZ6B097F4E,
            $key: $keyZ6B097F4E,
        });
    }
    else {
        return createElement("ul", {
            className: "m-0 p-0 flex flex-wrap justify-items-center items-center justify-evenly",
            children: Interop_reactApi.Children.toArray(Array.from(append(controls_1, jacks))),
        });
    }
}

export function view(model, dispatch) {
    const gridArea = (tupledArg, tupledArg_1) => {
        const rowStart = (tupledArg_1[1] + 1) | 0;
        const columnStart = (tupledArg_1[0] + 1) | 0;
        const rowEnd = (rowStart + tupledArg[1]) | 0;
        const columnEnd = (columnStart + tupledArg[0]) | 0;
        return toText(printf("%d/%d/%d/%d"))(rowStart)(columnStart)(rowEnd)(columnEnd);
    };
    const positionSet = (tupledArg_7) => {
        const col_1 = tupledArg_7[0] | 0;
        const row_1 = tupledArg_7[1] | 0;
        return (tupledArg_8) => ofSeq(delay(() => collect((c) => map_1((r) => [c, r], rangeDouble(row_1, 1, (row_1 + tupledArg_8[1]) - 1)), rangeDouble(col_1, 1, (col_1 + tupledArg_8[0]) - 1))), {
            Compare: (x, y_1) => compareArrays(x, y_1),
        });
    };
    const modList = toList_1(model.mods);
    let cells;
    const coveredCells = fold((s_2, tupledArg_9) => union(s_2, positionSet(tupledArg_9[0])(tupledArg_9[1].def.dimensions)), empty({
        Compare: (x_1, y_2) => compareArrays(x_1, y_2),
    }), modList);
    cells = append(map((position_1) => createElement(Components_BlankCell_53DCD2D1, {
        menuOpen: defaultArg(map_2((y) => equalArrays(position_1, y), model.addMenuPosition), false),
        gridArea: gridArea([1, 1], position_1),
        mods: map((tupledArg_6) => tupledArg_6[0], toList_1(defs)),
        onAddMod: (name_7) => {
            dispatch(new Message(2, position_1, name_7));
        },
        onOpenMenu: () => {
            dispatch(new Message(0, position_1));
        },
        onCloseMenu: () => {
            dispatch(new Message(5));
        },
    }), toList(difference(positionSet([0, 0])([5, 5]), coveredCells))), map((tupledArg_2) => {
        const position = tupledArg_2[0];
        const _arg1 = tupledArg_2[1];
        const modState = _arg1.state;
        const controlComponents = indexSet((tupledArg_3) => {
            const _arg3 = tupledArg_3[1];
            const label = _arg3.label;
            return createElement("li", {
                className: "w-12 flex flex-col items-center align-center",
                children: Interop_reactApi.Children.toArray(Array.from(toList_2(delay(() => append_1(singleton(createElement("span", {
                    className: "text-xs font-sans mb-0.5 uppercase",
                    children: label,
                })), delay(() => {
                    const config_1 = _arg3.config.fields[0];
                    return singleton(createElement("div", {
                        className: "w-9 h-9",
                        children: Interop_reactApi.Children.toArray([createElement(Controls_Knob_2C675436, {
                            min: config_1.min,
                            max: config_1.max,
                            steps: config_1.steps,
                            onChange: (v) => {
                                dispatch(new Message(14, new ControlChangeEvent(position, label, v)));
                            },
                            value: getFloatValue(label, modState),
                        })]),
                    }));
                })))))),
            });
        }, _arg1.def.controls);
        let jackComponents;
        const orNoop = (act) => ((msg) => (act ? (() => {
            dispatch(msg);
        }) : (() => {
        })));
        jackComponents = indexSet((tupledArg_4) => {
            const jack = tupledArg_4[1];
            const jackId = [position, tupledArg_4[0]];
            let validDest;
            const matchValue_1 = model.newCable;
            if (matchValue_1 == null) {
                validDest = true;
            }
            else {
                const startJackId = matchValue_1.start[0];
                validDest = (equalArrays(startJackId, jackId) ? true : (bind((startJack) => validateJackPair_1(startJackId, startJack, jackId, jack, model), getJack(startJackId[0], startJackId[1], model)) != null));
            }
            const validSrc = !containsKey(jackId, model.cables);
            let $keyZ3DC15F90;
            const tupledArg_5 = jackId;
            $keyZ3DC15F90 = toText(printf("%A"))([tupledArg_5[0], tupledArg_5[1]]);
            return createElement(Components_Jack_Z1AD9156D, {
                jack: jack,
                onMouseDown: orNoop(validSrc)(new Message(3, jackId)),
                onMouseUp: orNoop(validDest)(new Message(4, jackId)),
                enabled: validDest ? (!equals(model.loading, new LoadingState(1))) : false,
                onRender: (el) => {
                    const matchValue = tryFind(jackId, model.jackRefs);
                    let pattern_matching_result;
                    if (matchValue != null) {
                        if (equals(matchValue, el)) {
                            pattern_matching_result = 0;
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                    switch (pattern_matching_result) {
                        case 0: {
                            break;
                        }
                        case 1: {
                            dispatch(new Message(18, jackId, el));
                            break;
                        }
                    }
                },
                key: $keyZ3DC15F90,
                $key: $keyZ3DC15F90,
            });
        }, _arg1.def.jacks);
        return createElement(Components_Mod_4F7DC281, {
            gridArea: gridArea(_arg1.def.dimensions, position),
            name: _arg1.def.name,
            controls: controls(dispatch, position[0], position[1], modState, jackComponents, controlComponents),
            onRemove: () => {
                dispatch(new Message(1, position));
            },
        });
    }, modList));
    const newCableOrNoop = (fn) => {
        if (model.newCable != null) {
            return fn;
        }
        else {
            return (value_13) => {
            };
        }
    };
    let handleCancelChord;
    const handler = newCableOrNoop((_arg4_1) => {
        dispatch(new Message(8));
    });
    handleCancelChord = ((list_4) => map((event) => event(handler), list_4));
    const newChordEvents = cons(["onMouseMove", newCableOrNoop((e) => {
        const cursorPosition = [e.clientX, e.clientY];
        throttle(100, () => {
            dispatch(new Message(7, cursorPosition));
        });
    })], handleCancelChord(ofArray([(arg00_1) => ["onMouseUp", arg00_1], (arg00_2) => ["onMouseLeave", arg00_2]])));
    return createElement("div", createObj(append(newChordEvents, ofArray([["className", join(" ", ["p-2", "relative", "select-none", "h-full"])], ["children", Interop_reactApi.Children.toArray([createElement(Components_Cables_Z13D0F5DF, {
        jackRefs: model.jackRefs,
        cables: model.cables,
        newCable: model.newCable,
        onClick: (arg) => {
            dispatch(new Message(6, arg));
        },
    }), createElement("div", {
        className: "grid gap-2 h-full grid-cols-5 grid-rows-5",
        children: Interop_reactApi.Children.toArray(Array.from(cells)),
    })])]]))));
}

